var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.82L17.94 14.23L17.19 15.53L14 13.69V10H15.5V12.82ZM22 13C22 16.87 18.87 20 15 20C11.13 20 8 16.87 8 13C8 12.66 8.03 12.33 8.08 12H0V0H18V6.68C20.36 7.81 22 10.21 22 13ZM8.68 10C8.86 9.64 9.05 9.3 9.28 8.97C9.19 9 9.1 9 9 9C7.34 9 6 7.66 6 6C6 4.34 7.34 3 9 3C10.66 3 12 4.34 12 6C12 6.25 11.96 6.5 11.9 6.73C12.84 6.27 13.89 6 15 6C15.34 6 15.67 6.03 16 6.08V4C14.9 4 14 3.11 14 2H4C4 3.11 3.11 4 2 4V8C3.11 8 4 8.9 4 10H8.68ZM20 13C20 10.24 17.76 8 15 8C12.24 8 10 10.24 10 13C10 15.76 12.24 18 15 18C17.76 18 20 15.76 20 13Z",
    fill: "#FDDE7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashClock);
export default __webpack_public_path__ + "static/media/cash-clock.9e17de18373b6373e63296a3d48b2c75.svg";
export { ForwardRef as ReactComponent };